export enum PromocodeActionTypes {
  SET_PROMOCODE = 'SET_PROMOCODE',
}

export interface IPromocodeState {
  readonly code: string
  readonly terms: string
}
